import React, { FC, ReactNode } from 'react';
import { css } from '@emotion/css';
import useTheme from 'evcharging/hooks/useTheme';
import { Theme } from 'evcharging/app/themes';
import Box from 'evcharging/components/Box';
import { CONTACT_US_ANCHOR } from 'evcharging/app/seo/urls';
import LinkButton from 'evcharging/components/LinkButton';
import Desktop from 'evcharging/components/Desktop';
import useI18n from 'evcharging/hooks/useI18n';

interface OccpHeaderProps {
  children: ReactNode;
}

const OccpHeader: FC<OccpHeaderProps> = (props) => {
  const { children } = props;
  const theme = useTheme();
  const styles = createStyles(theme);
  const { t } = useI18n();

  return (
    <>
      <Box display={'flex'} alignItems={'center'} justifyContent={'space-between'}>
        <h1 className={styles.root}>{children}</h1>
        <Desktop>
          <LinkButton href={CONTACT_US_ANCHOR}>{t('ocpp.schedule')}</LinkButton>
        </Desktop>
      </Box>
    </>
  );
};

const createStyles = (theme: Theme) => ({
  root: css`
    font-weight: 700;
    font-size: 48px;
    line-height: 150%;
    color: #252c32;
    ${theme.breakpoints.mobile.down} {
      font-size: 32px;
      line-height: 130%;
    }
  `,
});

export default OccpHeader;
